import React from 'react';
import type { ColumnType } from 'antd/es/table';

export const TOGGLE_COLUMN_WIDTH = 150;

export const toggleColumnProps = {
  width: TOGGLE_COLUMN_WIDTH,
  align: 'center' as const,
  className: 'sec-tree-permissions-table-toggle-col',
  onHeaderCell: () => ({ className: 'sec-tree-permissions-table-toggle-col' }),
  onCell: () => ({ className: 'sec-tree-permissions-table-toggle-col' })
};

export const renderToggleCell = (switchNode: React.ReactNode) => (
  <div className="sec-tree-permissions-table-toggle-cell">{switchNode}</div>
);

export type ToggleColumnType<T> = ColumnType<T>;
